'use strict';

var CriteriaRuleModalDirective = function CriteriaRuleModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/criteria-rule-modal.html'),
    controller: 'CriteriaRuleModalController',
    link: function link() {}
  };
};
CriteriaRuleModalDirective.$inject = [];
module.exports = CriteriaRuleModalDirective;